import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react';
import LocationInputField from './LocationInputField';
import { states } from '../../utilities/constants';
import { AddressInput } from '../../types/google-maps';

// address state needs to be handled by parent so that this component remains as stateless as possible
type GoogleAddressFormProps = {
  addressInputFormData: AddressInput;
  setAddressInputFormData: React.Dispatch<React.SetStateAction<AddressInput>>;
};

export default function GoogleAddressForm(props: GoogleAddressFormProps) {
  // this state is used to manager what is typed in the address input field for google predictions
  const [addressInputValue, setAddressInputValue] = useState(
    props.addressInputFormData?.address1 || '',
  );

  return (
    <Grid container spacing={2} sx={styles.mainContainer}>
      <Grid item xs={12}>
        <LocationInputField
          addressInputValue={addressInputValue}
          setAddressInputValue={setAddressInputValue}
          onAddressSelect={address => {
            props.setAddressInputFormData({
              ...props.addressInputFormData,
              address1: address.address1 || '',
              city: address.city || '',
              state: address.state || '',
              zipcode: address.postalCode || '',
            });
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          size={'small'}
          label={'Address 2'}
          name={'address2'}
          value={props.addressInputFormData.address2 || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            props.setAddressInputFormData({
              ...props.addressInputFormData,
              address2: event.target.value,
            });
          }}
        />
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            multiline
            size={'small'}
            label={'City'}
            name={'city'}
            value={props.addressInputFormData.city || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              props.setAddressInputFormData({
                ...props.addressInputFormData,
                city: event.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth size={'small'}>
            <InputLabel>State</InputLabel>
            <Select
              fullWidth
              value={props.addressInputFormData.state || ''}
              label={'State'}
              onChange={event => {
                props.setAddressInputFormData({
                  ...props.addressInputFormData,
                  state: event.target.value,
                });
              }}
            >
              {states.map(state => (
                <MenuItem key={state.code} value={state.code}>
                  {state.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            multiline
            fullWidth
            size={'small'}
            label={'Zip'}
            name={'zipcode'}
            value={props.addressInputFormData.zipcode || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              props.setAddressInputFormData({
                ...props.addressInputFormData,
                zipcode: event.target.value,
              });
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingY: 2,
  },
};
